
export enum AnalyticsEvent {
  CLICK_ORDER_INFO_TAB = 'Order info tab clicked',
  CLICK_GALLERY_TAB = 'Gallery tab clicked',
  CLICK_GALLERY_STAGING = 'Gallery stage card clicked',
  CLICK_GALLERY_TAB_STAGE = 'Gallery stage tab clicked',
  CLICK_ORDER_DETAILS = 'See order details clicked',
  USE_GALLERY_FILTER = 'Gallery filter clicked',
  USE_COPY_LINK = 'Use Copy Link',
  GALLERY_PHOTO_FULL_PREVIEW = 'Full preview entered',
  CLICK_DOWNLOAD_VISUALS = 'Gallery floating bar download clicked',
  CLICK_EDIT_VISUALS = 'Gallery floating bar edit visuals clicked',
  CLICK_CONFIRM_VISUAL_SELECTION = 'Visual selection confirmed',
  GALLERY_SAAS_UPSELL_EDIT_VISUALS = 'Gallery saas upsell - edit visuals',
  GALLERY_SAAS_UPSELL_TEXT_GENERATOR = 'Gallery saas upsell - text generator',
  GALLERY_DOWNLOAD_TRIGGERED = 'download_triggered',
  GALLERY_MARK_FAVORITE = 'Gallery mark favorite',
  GALLERY_UNMARK_FAVORITE = 'Gallery unmark favorite',
  GALLERY_VIRTUAL_VISIT_OPEN_CSAT = 'Open gallery Virtual Visit CSAT',
  GALLERY_VIRTUAL_VISIT_CLOSE_CSAT = 'Close gallery Virtual Visit CSAT',
  GALLERY_FLOATING_BAR_EXPORT_OPTIONS = 'Gallery - floating bar export options',
  REVOKE_INVITATION = 'Revoke Invitation',
  CREATIVE_FIRST_TIME_DASHBOARD = 'creative_first_time_dashboard',
  CLIENT_FIRST_TIME_DASHBOARD = 'client_first_time_dashboard',
  UPLOAD_ERROR = 'Upload Error',
  MEMBER_INVITATION_UPSELL = 'Member invitation upsell',
  ADMIN_DASHBOARD_ORDER_STATUS_SELECTION = 'OPS Filter - Status Tab',
  CREATIVE_DASHBOARD_ORDER_STATUS_SELECTION = 'CT Filter - Status Tab',
  CLIENT_DASHBOARD_ORDER_STATUS_SELECTION_ALL_VISUALS = 'All Visuals Filter - Status Tab',
  CLIENT_DASHBOARD_ORDER_STATUS_SELECTION_MY_VISUALS = 'My Visuals Filter - Status Tab',
  DASHBOARD_ORDER_DATE_SELECTION_ALL_VISUALS = 'All Visuals Filter - Date Tab',
  DASHBOARD_ORDER_DATE_SELECTION_MY_VISUALS = 'My Visuals Filter - Date Tab',
  ORDER_PURCHASED = 'Purchased',
  CLICK_SAVE_TEMPLATE = 'Click Save Template',
  CANCEL_DOWNLOAD_BULK_EDITING = 'Cancel Download Bulk Editing',
  WORKSPACE_PROFILE_CLICK_DELETE_USER = 'Delete_User_Request',
  WORKSPACE_PROFILE_CLICK_ADD_MEMBER = 'Add_Member_Click',
  WORKSPACE_PROFILE_CLICK_UNSUBSCRIBE = 'Unsubscribe_Request',
  WORKSPACE_PROFILE_ENTERED_WORKSPACES_PROFILE = 'Workspaces_Profile_Click',
  WORKSPACE_PROFILE_MANAGE_BILLING = 'Manage Billing',
  PURCHASE_FLOW_VAT_DISPLAYED_ON_BILLING_STEP = 'VAT_number_input_displayed_on_order_billing_selection_screen',
  PURCHASE_FLOW_ENTERS_ORDER_BILLING_STEP = 'enters_order_billing_selection_screen',
  PURCHASE_FLOW_ENTERS_ORDER_INSTRUCTIONS_STEP = 'enters_order_instructions_selection_screen',
  PURCHASE_FLOW_PURCHASE = 'Purchase',
  STAGING_OPEN_COMMENT_POPUP = 'Staging_open_comment_popup',
  STAGING_SAVE_COMMENT_POPUP = 'Staging_save_comment_popup',
  STAGING_EDIT_COMMENT_POPUP = 'Staging_edit_comment_popup',
  STAGING_REMOVE_COMMENT = 'Staging_remove_comment',
  CLOSE_PURCHASE_FLOW = 'Close_purchase_flow',
  PURCHASE_FLOW_CLICK_PREVIOUS_STEP = 'Clicks_previous_step_purchase_flow',
  PURCHASE_FLOW_CLICK_NEXT_STEP = 'Clicks_next_step_purchase_flow',
  PURCHASE_FLOW_SIZE_PROPERTY_SELECTED = 'Size_property_selected',
  PURCHASE_FLOW_OPTION_SELECTED = 'option_selected',
  PURCHASE_FLOW_OPTION_REMOVED = 'option_removed',
  PURCHASE_FLOW_FAST_DELIVERY_SELECTED = 'fast_delivery_selected',
  PURCHASE_FLOW_FAST_DELIVERY_REMOVED = 'fast_delivery_removed',
  PURCHASE_FLOW_I_ON_SITE_SELECTED = 'I_am_on_site_selected',
  PURCHASE_FLOW_PAYMENT_METHOD_SELECTED = 'Payment_method_selected',
  PURCHASE_FLOW_PAYMENT_METHOD_SAVED = 'Payment_method_saved_as_default',
  PURCHASE_FLOW_ORGANISATION_METHOD_SELECTED = 'organisation_method_selected',
  ROOM_TYPE_SELECTED = 'Room_types_selected',
  ROOM_TYPE_SAVED = 'Room_types_saved',
  FURNITURE_FLOW_OPENED = 'Furniture_flow_opened',
  FURNITURE_FLOW_CLOSED = 'Furniture_flow_closed',
  FURNITURE_TEMPLATES_SELECTED = 'Furniture_templates_selected',
  FURNITURE_TEMPLATES_SAVED = 'Furniture_templates_saved',
  FURNITURE_TEMPLATES_FILTER = 'Furniture_templates_filter',
  FLOOR_FLOW_OPENED = 'Floor_flow_opened',
  FLOOR_FLOW_CLOSED = 'Floor_flow_closed',
  FLOOR_TEMPLATES_SELECTED = 'Floor_templates_selected',
  FLOOR_TEMPLATES_SAVED = 'Floor_templates_saved',
  DECORATION_FLOW_OPENED = 'Decoration_flow_opened',
  DECORATION_FLOW_CLOSED = 'Decoration_flow_closed',
  DECORATION_TEMPLATES_SELECTED = 'Decoration_templates_selected',
  DECORATION_TEMPLATES_SAVED = 'Decoration_templates_saved',
  WALL_FLOW_OPENED = 'Wall_flow_opened',
  WALL_FLOW_CLOSED = 'Wall_flow_closed',
  WALL_TEMPLATES_SELECTED = 'Wall_templates_selected',
  WALL_TEMPLATES_SAVED = 'Wall_templates_saved',
  REMOVED_OBJECT_TYPE = 'Removed_object_type',
  PROFOLIO_OPENED = 'Portfolio_opened',
  VISUAL_QUALITY_DECLINED = 'Visual_quality_declined',
  LET_BKBN_DECIDE_SELECTED = 'Let_bkbn_decide_selected',
  CUSTOMISE_MYSELF_SELECTED = 'Customise_myself_selected',
  CREATIVE_REMOVED_BY_ADMIN = 'creative_removed_by_admin',
  CREATIVE_SELECTED_BY_ADMIN = 'creative_selected_by_admin',
  CREATIVE_ONBOARDED_BY_ADMIN = 'onboard_creative',
  CLIENT_ONBOARDED_BY_ADMIN = 'onboard_client',
  GUIDELINES_DENIED = 'guidelines_denied',
  GUIDELINES_VALIDATED = 'guidelines_validated',
  CREATIVE_ACCEPTS_ASSIGNMENT = 'creative_accepts_assignment',
  CREATIVE_SELECTED_BY_CLIENT = 'creative_selected_by_client',
  SELECT_CREATIVE_OPTION_OPENED = 'select_creative_option_opened',
  FLOOR_PLAN_COLOR_SELECTED = 'floor_plan_color_selected',
  FLOOR_PLAN_CREATE_SELECTED = 'floor_plan_create_selected',
  FLOOR_PLAN_LOGO_UPLOADED = 'floor_plan_logo_uploaded',
  FLOOR_PLAN_OPTIONS_SELECTED = 'floor_plan_options_selected',
  FLOOR_PLAN_TEMPLATE_SELECTED = 'floor_plan_template_selected',
  FLOOR_PLAN_TYPE_SELECTED = 'floor_plan_type_selected',
  FLOOR_PLANNER_LINK_CLICKED = 'Floorplan_self_editing_link_opened',
  CLICK_BACKBONE_LOGO = 'Click Backbone Logo',
  CLICK_BACKBONE_PLAN_NAME = 'Click Backbone Plan Name',
  CLICK_MAIN_MENU = 'Click main menu',
  CLICK_ORDER_NEW_VISUALS = 'Click Order new visuals',
  CLICK_MAIN_MENU_MY_PLAN = 'Click main menu - My Plan',
  CLICK_MAIN_MENU_DASHBOARD = 'Click main menu - Dashboard',
  CLICK_MAIN_MENU_LANGUAGE = 'Click main menu - Language',
  CLICK_MAIN_MENU_LOCKED_PLAN_UPSELL = 'Click main menu - Locked Plan Upsell',
  CLICK_MAIN_MENU_PROFILE = 'Click main menu - Profile',
  CLICK_MAIN_MENU_USER_PROFILE = 'Click main menu - User Profile',
  CLICK_MAIN_MENU_HELP_CENTER = 'Click main menu - Help Center',
  CLICK_MAIN_MENU_CONTACT_US = 'Click main menu - Contact Us',
  CLICK_MAIN_MENU_TERMS_AND_POLICY = 'Click main menu - Terms & Policy',
  CLICK_MAIN_MENU_ORDER_NEW_VISUALS = 'Click main menu - Order new visuals',
  CLICK_MAIN_MENU_LOG_OUT = 'Click main menu - Log out',
  ENTER_ORDER_PROPERTY_INFO_PAGE_SCREEN = 'enters_order_property_information_page_screen',
  ENTER_ORDER_POA_PAGE_SCREEN = 'enters_order_power_attorney_page_screen',
  ENTER_ORDER_MEASUREMENTS_PAGE_SCREEN = 'enters_order_measurements_requirement_page_screen',
  ENTER_ORDER_LIVING_AREA_CALCULATION_PAGE_SCREEN = 'enters_order_living_area_calculation_requirement_page_screen',
  ENTER_ORDER_FLOOR_PLAN_PAGE_SCREEN = 'enters_order_floor_plan_requirement_page_screen',
  ENTER_ORDER_STAGING_PAGE_SCREEN = 'enters_order_staging_requirement_page_screen',
  ENTER_ORDER_CATEGORY_PAGE_SCREEN = 'enters_order_category_selection_screen',
  MEASUREMENTS_REQUIREMENT_SET_UP = 'measurements_requirement_set_up',
  LIVING_AREA_CALCULATION_REQUIREMENT_SET_UP = 'living_area_calculation_requirement_set_up',
  OPENS_BUILDING_LAYOUT = 'opens_building_layout',
  OPENS_CONSTRUCTION_METHOD = 'opens_construction_method',
  OPENS_VENTILATION_HEATING = 'opens_ventilation_heating',
  OPENS_ADDITIONAL_INFORMATION = 'opens_additional_information',
  OPENS_PROPERTY_INFORMATION = 'opens_property_information',
  OPENS_HEATING_SYSTEM = 'opens_heating_system',
  OPENS_CONSUMPTION_INFORMATION = 'opens_consumption_information',
  CC_EMAIL_ADDED = 'cc_email_added',
  CC_EMAIL_REMOVED = 'cc_email_removed',
  AI_STUDIO_OPENED = 'AI_studio_opened',
  PINTURA_EXIT = 'close_pintura',
  PINTURA_OPEN = 'open_pintura',
  PINTURA_SAVE_IMAGE = 'pintura_visual_saved',
  AI_STUDIO_SAVE_IMAGE = 'ai_studio_visual_saved',
  PINTURA_UPSELL_NON_SUBSCRIBER_BUTTON = 'upsell_pintura',
  PINTURA_CLOSE_UPSELL_ON_GALLERY = 'close_upsell_widget_gallery',
  PINTURA_UNDO = 'pintura_visual_editing_back',
  PINTURA_REDO = 'pintura_visual_editing_forward',
  MANUAL_ADDRESS_SELECTED = 'manual_address_selected',
  MANUAL_ADDRESS_UNSELECTED = 'manual_address_unselected',
  CLICK_PROPERTY_VISUALS_GALLERY_TAB = 'property_visuals_gallery_tab_clicked',
  CLICK_PROPERTY_DOCUMENTS = 'property_documents_tab_clicked',
  CLICK_PROPERTY_AI_TEXT_GENERATOR_TAB = 'property_ai_text_generator_tab_clicked',
  CLICK_PROPERTY_ORDERS_TAB = 'property_orders_tab_clicked',
  CLICK_PROPERTY_INFORMATION_TAB = 'property_information_tab_clicked',
  CLICK_AI_EDITING_OPTIONS = 'AI_options_selected',
  PURCHASE_AI_VISUALS_IN_GALLERY = 'AI_visuals_purchased',
  OPEN_PROPERTY = 'open_property',
  OPEN_PROPERTY_DASHBOARD = 'open_property_dashboard',
  FILTER_PROPERTY = 'filter_property',
  PROPERTY_DOWNLOAD_VISUALS = 'property_download_visuals',
  PROPERTY_ORDER_VISUALS_CLICKED = 'property_order_visuals_clicked',
  PROPERTY_ORDER_VISUALS_OVERVIEW_HEADER_CLICKED = 'property_order_visuals_overview_header_clicked',
  PROPERTY_DOWNLOAD_DOCUMENTS = 'property_download_documents',
  PROPERTY_ACTION_REQUIRED_CLICKED = 'property_action_required_clicked',
  PROPERTY_CREATED = 'property_created',
  AI_EDITED_VISUAL_RATING = 'AI_edited_visual_rating',
  INVOICE_DOWNLOADED = 'invoice_downloaded',
  SELF_UPLOAD_CLICK = 'click_upload_visuals',
  SELF_UPLOAD_NEXT_STEP = 'upload_visuals_next_step',
  SELF_UPLOAD_OPTIONS_SELECTED = 'Upload_options_selected',
}
